//libraries
import React, { FunctionComponent, useEffect, useState, useRef } from 'react';
import { Row, Col, Navbar, Container, Nav, Image, Dropdown, NavDropdown, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import SessionService from '../../services/SessionsService';
import { Link, Redirect, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import Cookies from 'universal-cookie';
// import './NewLandingFramework.css'

//components
import FooterMenuAccess from '../../components/functionalComponents/DashboardLayout/FooterMenu';
import NavbarMarket from '../../components/functionalComponents/baseLayout/navbar';

//assets
import favicon from '../../assets/img/Favicon_AVAP_Marketplace.png'

import grid from '../../assets/img/iconos-iconos.png'
import lines from '../../assets/img/iconos-lineas.png'

import ReactGA from 'react-ga4';
import config from '../../configs/appConfig.json'


import icon_dev from '../../assets/img/logos/icono_DSs.svg'
import icon_publisher from '../../assets/img/logos/icono_publisher.svg'
import icon_linter from '../../assets/img/logos/icon_avap.svg'
import logo_cloud from '../../assets/img/AVAP_Cloud.svg'
import defaultImage from '../../assets/img/ui_icons/noIcon.svg'





import { BrowserView, MobileView } from 'react-device-detect';


type DashProps = {
    sider: any
};



const myApis = () => {

    const [showInline, setShowInline] = useState(true)
    const [apps, setApps] = useState([]);
    const cookies = new Cookies();
    const history = useHistory();
    const [totalLive, setTotalLive] = useState(0);
    const [totalModify, setTotalModify] = useState(0);
    const [totalDraft, setTotalDraft] = useState(0);


    const getApps = async () => {
        try {
            const result = (await ObexRequestHandler.get('/dev_api_product_list')).data;
            setApps(result);
            console.log("------------")
            console.log(result)
            console.log("------------")

            let liv = 0;
            let drf = 0;
            let modt = 0;
            result.forEach(element => {
                if (element.status == 'Live') liv++;
                else if (element.status == 'Draft') drf++;
                else modt++;
            });


            setTotalLive(liv);
            setTotalDraft(drf);
            setTotalModify(modt);

        } catch (error) {
            console.error('ERROR FETCHING APPS ', error);
        }
    }


    useEffect(() => {
        getApps()
        // favicon
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);

        const user = cookies.get('101Obex');
        if (!user) {
            // Si no existe, redirigir al login
            history.push('/login');
        }

        // favicon

        return () => {
            document.head.removeChild(link);
        };
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0);
        //ReactGA.initialize('G-MQZQJN7TQL');
        if (true) {
            ReactGA.initialize('G-5J60GTNR8T');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Marketplace | API Products' });
        }

    }, []);





    return (
        <>
            <NavbarMarket />

            { showInline ? 

            <div id='mktmyApis' className="w-100 bg-antiflash ">
                <div className="container pt-5" style={{paddingBottom:'10px'}}>
                    <div className="row">
                        <div className="col" style={{display:'flex'}}>
                            <p style={{width:'50%'}} className="subtitulo">My API Products</p>
                            <p style={{width:'50%', textAlign:'end'}} className="subtitulo">
                            <Image style={{height:'35px', cursor:'pointer'}} src={grid} onClick={()=>{setShowInline(false)}}/>

                            </p>
                            <hr className='mb-5' />
                        </div>
                    </div>
                    {/* 
                    <div className="row">
                        {apps.map((item) => (
                            <div className="col-md-4">
                                <a href={`/myApis/details/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="apiCard">
                                    <div className="top">
                                        <Image className='apiLogo' src={item.icon ? atob(item.icon).toString() : null} />
                                        <div className="info">
                                            <p className='apiName'>{item.name}</p>
                                            <p className='devName'>{item.devName}</p>
                                            <p className='cat'><span className='txt-bold'>Certification status: </span> <span className={'status ' + (item.status.includes('Rejected') ? 'rejected' : item.status.toLowerCase())}>{item.status.includes('Rejected') ? 'Rejected' : item.status}</span> </p>
                                            <p className='cat'>{item.category}</p>

                                        </div>
                                    </div>
                                    <div className="bottom">
                                        <Image src={logo_cloud} />
                                        <p className='version'>Version {item.version}</p>
                                    </div>
                                </a>
                            </div>
                        ))} */}

                    {/* <div className="col-md-4">
                            <a href='/myApis/details' className="apiCard">
                                <div className="top">
                                    <Image className='apiLogo' src={icon_linter} />
                                    <div className="info">
                                        <p className='apiName'>AVAP Dev Extension</p>
                                        <p className='devName'>Developer Name</p>
                                        <p className='cat'><span className='txt-bold'>Certification status: </span> <span className='status live'>Live</span> </p>
                                        <p className='cat'>Category</p>
                                  
                                    </div>
                                </div>
                                <div className="bottom">
                                    <Image src={logo_cloud} />
                                    <p className='version'>Version 1.23.45</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-md-4">
                            <a href='/myApis/details' className="apiCard">
                                <div className="top">
                                    <Image className='apiLogo' src={icon_dev} />
                                    <div className="info">
                                        <p className='apiName'>AVAP Dev Extension</p>
                                        <p className='devName'>Developer Name</p>
                                        <p className='cat'><span className='txt-bold'>Certification status: </span> <span className='status rejected'>Rejected</span> </p>
                                        <p className='cat'>Category</p>
                                   
                                    </div>
                                </div>
                                <div className="bottom">
                                    <Image src={logo_cloud} />
                                    <p className='version'>Version 1.23.45</p>
                                </div>
                            </a>
                        </div>

                        <div className="col-md-4">
                            <a href='/myApis/details' className="apiCard">
                                <div className="top">
                                    <Image className='apiLogo' src={icon_dev} />
                                    <div className="info">
                                        <p className='apiName'>AVAP Dev Extension</p>
                                        <p className='devName'>Developer Name</p>
                                        <p className='cat'><span className='txt-bold'>Certification status: </span> <span className='status approved'>Approved</span> </p>
                                        <p className='cat'>Category</p>
                           
                                    </div>
                                </div>
                                <div className="bottom">
                                    <Image src={logo_cloud} />
                                    <p className='version'>Version 1.23.45</p>
                                </div>
                            </a>
                        </div> */}
                    {/* </div> */}
                    <div className="row" style={{marginBottom:'20px'}}>
                        <div className="col-12" style={{marginBottom:'10px'}}>
                            <p className="subtitulo">Live ({totalLive})</p>
                            
                        </div>

                        {apps.filter((item) => item.status === "Live").length > 0 ? (
                            apps
                                .filter((item) => item.status === "Live")
                                .map((item) => (
                                    <div className="" key={item.api_product_id} style={{width:'100%'}}>
                                        <a href={`/myApis/details/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="apiCard" style={{height:'70px'}}>
                                            <div className="top" style={{width:'100%', marginTop:'5px'}}>
                                                <Image style={{height:'32px',marginTop:'5px'}} className='apiLogo' src={item.icon && item.icon.trim() !== '' ? atob(item.icon).toString() : defaultImage} />
                                                <div className="" style={{display:'flex', width:'100%'}}>
                                                    <div style={{minWidth:'33%', paddingTop:'0px'}}>
                                                    <p className='apiName'>{item.name}</p>
                                                    <p style={{color:'gray'}} className='devName'>{item.devName}</p>
                                                    </div>
                                                    <div style={{minWidth:'33%', paddingTop:'3px'}}>
                                                    <p className='cat'>
                                                        <span className='txt-bold'>Certification status: </span>
                                                        <span className={'status ' + (item.status.includes('Rejected') ? 'rejected' : item.status.toLowerCase())}>
                                                            {item.status.includes('Rejected') ? 'Rejected' : item.status}
                                                        </span>
                                                    </p>
                                                    <p className='cat'>{item.category}</p>
                                                    </div>
                                                    
                                                    <div className="" style={{minWidth:'33%', paddingTop:'0px', textAlign:'end', paddingLeft:'00px'}}>
                                                        <Image style={{height:'15px'}} src={logo_cloud} />
                                                        <p style={{fontSize:'12px', color:'black'}} className='version'>Version {item.version}</p>
                                                    </div>





                                                </div>
                                            </div>

                                        </a>
                                    </div>
                                ))
                        ) : (
                            <div className="col-12">
                                <p>No elements Live to display</p>
                            </div>// Mensaje cuando no hay drafts
                        )}
                        
                    </div>
                    <hr></hr>
                    <div className="row" style={{marginBottom:'20px'}}>
                        <div className="col-12" style={{marginBottom:'10px'}}>
                            <p className="subtitulo">API Products with recent updates ({totalModify})</p>
                        </div>

                        {apps.filter((item) => item.status !== "Draft" && item.status !== "Live").length > 0 ? (
                            apps
                                .filter((item) => item.status !== "Draft" && item.status !== "Live")
                                .map((item) => (
                                    <div className="" key={item.api_product_id} style={{width:'100%'}}>
                                        <a href={`/myApis/details/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="apiCard" style={{height:'70px'}}>
                                            <div className="top" style={{width:'100%', marginTop:'5px'}}>
                                                <Image style={{height:'32px',marginTop:'5px'}} className='apiLogo' src={item.icon && item.icon.trim() !== '' ? atob(item.icon).toString() : defaultImage} />
                                                <div className="" style={{display:'flex', width:'100%'}}>
                                                    <div style={{minWidth:'33%', paddingTop:'0px'}}>
                                                    <p className='apiName'>{item.name}</p>
                                                    <p style={{color:'gray'}} className='devName'>{item.devName}</p>
                                                    </div>
                                                    <div style={{minWidth:'33%', paddingTop:'3px'}}>
                                                    <p className='cat'>
                                                        <span className='txt-bold'>Certification status: </span>
                                                        <span className={'status ' + (item.status.includes('Rejected') ? 'rejected' : item.status.toLowerCase())}>
                                                            {item.status.includes('Rejected') ? 'Rejected' : item.status}
                                                        </span>
                                                    </p>
                                                    <p className='cat'>{item.category}</p>
                                                    </div>
                                                    
                                                    <div className="" style={{minWidth:'33%', paddingTop:'0px', textAlign:'end', paddingLeft:'00px'}}>
                                                        <Image style={{height:'15px'}} src={logo_cloud} />
                                                        <p style={{fontSize:'12px', color:'black'}} className='version'>Version {item.version}</p>
                                                    </div>





                                                </div>
                                            </div>

                                        </a>
                                    </div>
                                ))
                        ) : (
                            <div className="col-12">
                                <p>There are no API products with recent updates.</p>
                            </div>
                        )}

                    </div>
                    <hr></hr>
                    <div className="row" style={{marginBottom:'20px'}}>
                        <div className="col-12" style={{marginBottom:'10px'}}>
                            <p className="subtitulo">Drafts  ({totalDraft})</p>
                        </div>

                        {apps.filter((item) => item.status === "Draft").length > 0 ? (
                            apps
                                .filter((item) => item.status === "Draft")
                                .map((item) => (
                                    <div className="" key={item.api_product_id} style={{width:'100%'}}>
                                        <a href={`/myApis/details/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="apiCard" style={{height:'70px'}}>
                                            <div className="top" style={{width:'100%', marginTop:'5px'}}>
                                                <Image style={{height:'32px',marginTop:'5px'}} className='apiLogo' src={item.icon && item.icon.trim() !== '' ? atob(item.icon).toString() : defaultImage} />
                                                <div className="" style={{display:'flex', width:'100%'}}>
                                                    <div style={{minWidth:'33%', paddingTop:'0px'}}>
                                                    <p className='apiName'>{item.name}</p>
                                                    <p style={{color:'gray'}} className='devName'>{item.devName}</p>
                                                    </div>
                                                    <div style={{minWidth:'33%', paddingTop:'3px'}}>
                                                    <p className='cat'>
                                                        <span className='txt-bold'>Certification status: </span>
                                                        <span className={'status ' + (item.status.includes('Rejected') ? 'rejected' : item.status.toLowerCase())}>
                                                            {item.status.includes('Rejected') ? 'Rejected' : item.status}
                                                        </span>
                                                    </p>
                                                    <p className='cat'>{item.category}</p>
                                                    </div>
                                                    
                                                    <div className="" style={{minWidth:'33%', paddingTop:'0px', textAlign:'end', paddingLeft:'00px'}}>
                                                        <Image style={{height:'15px'}} src={logo_cloud} />
                                                        <p style={{fontSize:'12px', color:'black'}} className='version'>Version {item.version}</p>
                                                    </div>





                                                </div>
                                            </div>

                                        </a>
                                    </div>
                                ))
                        ) : (
                            <div className="col-12">
                                <p>No elements in drafts to display</p>
                            </div>
                        )}
                    </div>
                    <hr></hr>
                </div>
            </div>
            : 
            <div id='mktmyApis' className="w-100 bg-antiflash ">
                <div className="container pt-5" style={{paddingBottom:'10px'}}>
                    <div className="row">
                    <div className="col" style={{display:'flex'}}>
                            <p style={{width:'50%'}} className="subtitulo">My API Products</p>
                            <p style={{width:'50%', textAlign:'end'}} className="subtitulo">
                            <Image style={{height:'35px', cursor:'pointer'}} src={lines} onClick={()=>{setShowInline(true)}}/>

                            </p>
                            <hr className='mb-5' />
                        </div>
                    </div>
                    {/* 
                    <div className="row">
                        {apps.map((item) => (
                            <div className="col-md-4">
                                <a href={`/myApis/details/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="apiCard">
                                    <div className="top">
                                        <Image className='apiLogo' src={item.icon ? atob(item.icon).toString() : null} />
                                        <div className="info">
                                            <p className='apiName'>{item.name}</p>
                                            <p className='devName'>{item.devName}</p>
                                            <p className='cat'><span className='txt-bold'>Certification status: </span> <span className={'status ' + (item.status.includes('Rejected') ? 'rejected' : item.status.toLowerCase())}>{item.status.includes('Rejected') ? 'Rejected' : item.status}</span> </p>
                                            <p className='cat'>{item.category}</p>

                                        </div>
                                    </div>
                                    <div className="bottom">
                                        <Image src={logo_cloud} />
                                        <p className='version'>Version {item.version}</p>
                                    </div>
                                </a>
                            </div>
                        ))} */}

                    {/* <div className="col-md-4">
                            <a href='/myApis/details' className="apiCard">
                                <div className="top">
                                    <Image className='apiLogo' src={icon_linter} />
                                    <div className="info">
                                        <p className='apiName'>AVAP Dev Extension</p>
                                        <p className='devName'>Developer Name</p>
                                        <p className='cat'><span className='txt-bold'>Certification status: </span> <span className='status live'>Live</span> </p>
                                        <p className='cat'>Category</p>
                                  
                                    </div>
                                </div>
                                <div className="bottom">
                                    <Image src={logo_cloud} />
                                    <p className='version'>Version 1.23.45</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-md-4">
                            <a href='/myApis/details' className="apiCard">
                                <div className="top">
                                    <Image className='apiLogo' src={icon_dev} />
                                    <div className="info">
                                        <p className='apiName'>AVAP Dev Extension</p>
                                        <p className='devName'>Developer Name</p>
                                        <p className='cat'><span className='txt-bold'>Certification status: </span> <span className='status rejected'>Rejected</span> </p>
                                        <p className='cat'>Category</p>
                                   
                                    </div>
                                </div>
                                <div className="bottom">
                                    <Image src={logo_cloud} />
                                    <p className='version'>Version 1.23.45</p>
                                </div>
                            </a>
                        </div>

                        <div className="col-md-4">
                            <a href='/myApis/details' className="apiCard">
                                <div className="top">
                                    <Image className='apiLogo' src={icon_dev} />
                                    <div className="info">
                                        <p className='apiName'>AVAP Dev Extension</p>
                                        <p className='devName'>Developer Name</p>
                                        <p className='cat'><span className='txt-bold'>Certification status: </span> <span className='status approved'>Approved</span> </p>
                                        <p className='cat'>Category</p>
                           
                                    </div>
                                </div>
                                <div className="bottom">
                                    <Image src={logo_cloud} />
                                    <p className='version'>Version 1.23.45</p>
                                </div>
                            </a>
                        </div> */}
                    {/* </div> */}
                    <div className="row" style={{marginBottom:'20px'}}>
                        <div className="col-12" style={{marginBottom:'10px'}}>
                            <p className="subtitulo">Live  ({totalLive})</p>
                            
                        </div>

                        {apps.filter((item) => item.status === "Live").length > 0 ? (
                            apps
                                .filter((item) => item.status === "Live")
                                .map((item) => (
                                    <div className="col-lg-4 col-md-6" key={item.api_product_id}>
                                        <a href={`/myApis/details/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="apiCard">
                                            <div className="top">
                                                <Image className='apiLogo' src={item.icon && item.icon.trim() !== '' ? atob(item.icon).toString() : defaultImage} />
                                                <div className="info">
                                                    <p className='apiName'>{item.name}</p>
                                                    <p className='devName'>{item.devName}</p>
                                                    <p className='cat'>
                                                        <span className='txt-bold'>Certification status: </span>
                                                        <span className={'status ' + (item.status.includes('Rejected') ? 'rejected' : item.status.toLowerCase())}>
                                                            {item.status.includes('Rejected') ? 'Rejected' : item.status}
                                                        </span>
                                                    </p>
                                                    <p className='cat'>{item.category}</p>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Image src={logo_cloud} />
                                                <p className='version'>Version {item.version}</p>
                                            </div>
                                        </a>
                                    </div>
                                ))
                        ) : (
                            <div className="col-12">
                                <p>No elements Live to display</p>
                            </div>// Mensaje cuando no hay drafts
                        )}
                        
                    </div>
                    <hr></hr>
                    <div className="row" style={{marginBottom:'20px'}}>
                        <div className="col-12" style={{marginBottom:'10px'}}>
                            <p className="subtitulo">API Products with recent updates  ({totalModify})</p>
                        </div>

                        {apps.filter((item) => item.status !== "Draft" && item.status !== "Live").length > 0 ? (
                            apps
                                .filter((item) => item.status !== "Draft" && item.status !== "Live")
                                .map((item) => (
                                    <div className="col-lg-4 col-md-6" key={item.api_product_id}>
                                        <a href={`/myApis/details/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="apiCard">
                                            <div className="top">
                                                <Image className='apiLogo' src={item.icon && item.icon.trim() !== '' ? atob(item.icon).toString() : defaultImage} />
                                                <div className="info">
                                                    <p className='apiName'>{item.name}</p>
                                                    <p className='devName'>{item.devName}</p>
                                                    <p className='cat'>
                                                        <span className='txt-bold'>Certification status: </span>
                                                        <span className={'status ' + (item.status.includes('Rejected') ? 'rejected' : item.status.toLowerCase())}>
                                                            {item.status.includes('Rejected') ? 'Rejected' : item.status}
                                                        </span>
                                                    </p>
                                                    <p className='cat'>{item.category}</p>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Image src={logo_cloud} />
                                                <p className='version'>Version {item.version}</p>
                                            </div>
                                        </a>
                                    </div>
                                ))
                        ) : (
                            <div className="col-12">
                                <p>There are no API products with recent updates.</p>
                            </div>
                        )}

                    </div>
                    <hr></hr>
                    <div className="row" style={{marginBottom:'20px'}}>
                        <div className="col-12" style={{marginBottom:'10px'}}>
                            <p className="subtitulo">Drafts  ({totalDraft})</p>
                        </div>

                        {apps.filter((item) => item.status === "Draft").length > 0 ? (
                            apps
                                .filter((item) => item.status === "Draft")
                                .map((item) => (
                                    <div className="col-lg-4 col-md-6" key={item.api_product_id}>
                                        <a href={`/myApis/details/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="apiCard">
                                            <div className="top">
                                                <Image className='apiLogo' src={item.icon && item.icon.trim() !== '' ? atob(item.icon).toString() : defaultImage} />
                                                <div className="info">
                                                    <p className='apiName'>{item.name}</p>
                                                    <p className='devName'>{item.devName}</p>
                                                    <p className='cat'>
                                                        <span className='txt-bold'>Certification status: </span>
                                                        <span className={'status ' + (item.status.includes('Rejected') ? 'rejected' : item.status.toLowerCase())}>
                                                            {item.status.includes('Rejected') ? 'Rejected' : item.status}
                                                        </span>
                                                    </p>
                                                    <p className='cat'>{item.category}</p>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Image src={logo_cloud} />
                                                <p className='version'>Version {item.version}</p>
                                            </div>
                                        </a>
                                    </div>
                                ))
                        ) : (
                            <div className="col-12">
                                <p>No elements in drafts to display</p>
                            </div>
                        )}
                    </div>
                    <hr></hr>
                </div>
            </div>
}
            <FooterMenuAccess green={true} />

        </>
    )
}

export default myApis;